// 数据查询模块
import Axios from './config'

//获取页面左侧的menu
const getMenu = (params) => {
  return Axios({
    method: 'get',
    url: `/web/pubitem/itemResource/getItemTree`,
    params: params
  })
}
/* //获取页面左侧menu对应的数据
const getData = () => {
  return Axios({
    method: 'get',
    url: './static/data.json'
  })
} */
//获取页面左侧menu对应的数据
const getData = (params) => {
  return Axios({
    method: 'post',
    url: `/web/pubitem/dataIndicator/indicatorDetail`,
    data: params
  })
}
//导出数据
const exportFn = (params) => {
  return Axios({
    method: 'post',
    url: `/web/indicatorData/excel`,
    responseType: 'blob',
    data: params
  })
}
//下载图片
const downloadFn = (params) => {
  return Axios({
    method: 'get',
    url: `/web/dataIndicator/indicatorDetail/commonRequest`,
    params: params
  })
}



export{
    getMenu,
    getData,
    exportFn,
    downloadFn
}


// WEBPACK FOOTER //
// ./src/api/dataQuery.js